import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { DRAW_IGNORE_ZONES_COPY } from "./receiverDescriptions";
import { ReceiverKey } from "./receiverConfigs";

/**
 * Labelled replacement for the bare "Draw Ignore Zones" switch (ENG-2483).
 * Writes the same draw_ignore_zones boolean. Only rendered for receivers that
 * get images we can draw on (Immix, Dice, Sentinel).
 */
export const DrawIgnoreZonesChoice = ({
  receiver,
  name,
  value,
  onChange,
  disabled = false,
}: {
  receiver: ReceiverKey;
  name: string;
  value: boolean;
  onChange: (drawIgnoreZones: boolean) => void;
  disabled?: boolean;
}) => {
  const copy = DRAW_IGNORE_ZONES_COPY[receiver];
  if (!copy) return null;
  const labelId = `${name}-label`;
  return (
    <div className="mt-2" data-testid="draw-ignore-zones-choice">
      <span id={labelId} className="text-[14px] font-bold">
        Ignore zones on {copy.appliesTo}
      </span>
      <RadioGroup
        row
        aria-labelledby={labelId}
        name={name}
        value={value ? "draw" : "plain"}
        onChange={(event) => {
          const next = event.target.value === "draw";
          onChange(next);
        }}
      >
        <FormControlLabel
          value="plain"
          disabled={disabled}
          control={<Radio size="small" color="warning" />}
          label={<span className="text-[14px]">Not drawn</span>}
        />
        <FormControlLabel
          value="draw"
          disabled={disabled}
          control={<Radio size="small" color="warning" />}
          label={<span className="text-[14px]">Drawn</span>}
        />
      </RadioGroup>
      <p className="text-[13px] text-[#5B6B86]">{copy.note}</p>
    </div>
  );
};
